'use client';

/**
 * MMM Global Plan - Custom Layout
 * All components are specific to this plan only, kept in this folder.
 */

import { PlanIntroSection } from '../common/plan-intro-section';
import { FeaturesSection } from '../common/features-section';
import { WhySoftwareSection } from '../common/why-software-section';
import { HowSoftwareWorksSection } from '../common/how-software-works-section';
import { WhatIsSoftwareSection } from '../common/what-is-software-section';
import { CommissionsSection } from '../common/commissions-section';
import { WhatIsPlanSection } from './WhatIsPlanSection';
import { UserPlus, Users, Bitcoin, GraduationCap, Zap, Share2 } from 'lucide-react';

interface MLMPlan {
  slug: string;
  name: string;
  description: string;
  content: string;
  image?: string;
  features?: string[];
}

interface PlanDetailContentProps {
  plan: MLMPlan;
}

export default function PlanDetailContent({ plan }: PlanDetailContentProps) {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-950">
      <PlanIntroSection
        plan={plan}
        translationNamespace="planDetails.mmmGlobalPlan.hero"
        imageSrc="/images/mlm-plans/MMM Global.webp"
        descriptionKeys={['description1', 'description2']}
      />
      <WhatIsPlanSection plan={plan} />
      <WhatIsSoftwareSection
        plan={plan}
        translationNamespace="planDetails.mmmGlobalPlan.whatIsSoftware"
        imageSrc="/images/mlm-plans/MMM Global.webp"
      />
      <HowSoftwareWorksSection plan={plan} translationNamespace="planDetails.mmmGlobalPlan.howSoftwareWorks" />
      <FeaturesSection plan={plan} translationNamespace="planDetails.mmmGlobalPlan.features" />
      <CommissionsSection
        plan={plan}
        translationNamespace="planDetails.mmmGlobalPlan.commissions"
        commissions={[
          { icon: UserPlus, color: 'primary', titleKey: 'register.title', descriptionKey: 'register.description' },
          { icon: Users, color: 'blue', titleKey: 'referral.title', descriptionKey: 'referral.description' },
          { icon: Bitcoin, color: 'green', titleKey: 'bitcoin.title', descriptionKey: 'bitcoin.description' },
          { icon: GraduationCap, color: 'purple', titleKey: 'guider.title', descriptionKey: 'guider.description' },
          { icon: Zap, color: 'orange', titleKey: 'sponsor.title', descriptionKey: 'sponsor.description' },
          { icon: Share2, color: 'pink', titleKey: 'socialShare.title', descriptionKey: 'socialShare.description' },
        ]}
        gridCols="3"
        hasDescription={true}
      />
      <WhySoftwareSection plan={plan} translationNamespace="planDetails.mmmGlobalPlan.whySoftware" />
    </div>
  );
}
